<template lang='pug'>
  .inner-header
    .sessions
      a.btn.register(:href='registerPath()' v-text='signUpButtonText')
      .or(v-text='"or"')
      a.btn.sign-in(:href='signInPath()' v-text='signInButtonText')
</template>

<i18n>
{
  "lng_en": {
    "heading": "Beauty Pass is an all-access pass to a bounty of beauty rewards. It's free to join, and every %{amount} spent earns a point that gets you closer to your next beauty fix.",
    "join": "join beauty pass",
    "signIn": "sign in"
  },
  "lng_id": {
    "heading": "Beauty Pass adalah sebuah membership dengan akses penuh untuk beauty rewards yang luar biasa. Gratis untuk bergabung, dan untuk setiap Rp %{amount} yang dibelanjakan akan mendapatkan 1 poin yang membawa Anda lebih dekat kepada keuntungan dan hadiah menarik.",
    "join": "Daftar Beauty Pass",
    "signIn": "Masuk"
  },
  "lng_th": {
    "heading": "รับของรางวัลและสิทธิประโยชน์สุดเลิศจาก Beauty Pass ได้เลย ลงทะเบียนฟรีวันนี้ พร้อมรับ 1 คะแนนสะสมเมื่อช้อปครบทุก %{amount} บาท",
    "join": "สมัคร Beauty Pass",
    "signIn": "ลงชื่อเข้าใช้"
  },
  "lng_zh": {
    "heading": "Beauty Pass計劃爲你帶來無窮無盡的美妝獎賞。會籍費用全免，每消費%{amount}即可獲得1積分，隨時兌換心頭好。",
    "join": "加入Beauty Pass",
    "signIn": "登入"
  },
  "lng_ko": {
    "heading": " 뷰티패스는 넘치는 뷰티 혜택을 모두 누릴 수 있는 패스입니다.가 입은 무료이며 %{amount} 구매 시마다 오프라인 1포인트 온라인 1.2포인트(현지 기준)를 적립하여 적립된 포인트는 다음 구매에 사용할 수 있습니다. ",
    "join": "뷰티 패스 가입하기",
    "signIn": "로그인"
  }
}
</i18n>

<script>
import { sessionUtil } from '@/mixins/pathUtil'

export default {
  mixins: [
    sessionUtil
  ],
  props: {
    earnAmountText: String
  },

  computed: {
    headingText () {
      return `${this.$t('heading', { amount: this.earnAmountText })}`
    },

    signUpButtonText () {
      return this.$t('account.rewardsBoutique.guestHeader.signUp')
    },

    signInButtonText () {
      return this.$t('account.rewardsBoutique.guestHeader.signIn')
    }
  }
}
</script>

<style lang='scss' scoped>
  .inner-header {
    align-self: flex-end;
    bottom: -52px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    position: relative;
    width: 100%;

    @include media-breakpoint-down(sm) {
      bottom: -52px;
    }

    @include media-breakpoint-up(sm) {
      bottom: -60px;
      width: 566px;
    }

    @include media-breakpoint-up(xl) {
      margin-left: auto;
      margin-right: auto;
      position: static;
      width: 545px;
    }

    > .text {
      margin: 15px auto;
      width: 280px;
      font-size: 14px;

      @include media-breakpoint-up(sm) {
        width: 380px;
      }

      @include media-breakpoint-up(lg) {
        width: 450px;
      }

      @include media-breakpoint-up(xl) {
        margin-bottom: 20px;
        width: 100%;
      }
    }

    > .sessions {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin: 5px;

      .sign-in,
      .register {
        @include media-breakpoint-down(sm) {
          font-size: 14px;
        }
      }

      @include media-breakpoint-up(sm) {
        margin-top: 10px;
        max-width: 566px;
      }

      @include media-breakpoint-up(xl) {
        margin: 0;
        width: 100%;
      }
    }
  }

  .header-wrapper {
    @include media-breakpoint-up(sm) {
      background-size: cover;
      flex-direction: column;
      height: 170px;
      justify-content: center;
      margin-bottom: 0;
      width: 80%;
      padding: 10px;
    }

    .inner-header {
      @include media-breakpoint-up(sm) {
        bottom: 0;
        margin-top: 60px;
        width: 566px;
      }

      @include media-breakpoint-down(lg) {
        margin-top: 40px;
      }

      @media (max-width: 768px) {
        width: 450px; // for portrait tablet
      }

      @include media-breakpoint-down(sm) {
        bottom: -2px;
        width: auto;
      }

      @include media-breakpoint-only(xs) {
        margin-top: 30px;  // mobile
      }

      > .sessions {
        @include media-breakpoint-up(sm) {
          margin-top: 10px;
          max-width: 500px;
        }

        @include media-breakpoint-up(lg) {
          max-width: none;
        }

        @include media-breakpoint-up(xl) {
          max-width: none;
        }
      }
    }
  }

  .sessions {
    > .register {
      flex-grow: 1;
      text-transform: uppercase;
    }

    > .or {
      margin-left: 6px;
      margin-right: 6px;

      @include media-breakpoint-up(sm) {
        margin-left: 20px;
        margin-right: 20px;
      }
    }

    > .sign-in {
      background: white;
      border: 1px solid black;
      color: black;
      flex-grow: 1;
      text-transform: uppercase;
    }
  }
</style>
